import React from 'react';
import { Link } from 'react-router-dom';
import M from '@materializecss/materialize';
import { connect } from 'react-redux';

class SideNav extends React.Component {
  constructor(props) {
    super(props);
    this.employeeData = JSON.parse(localStorage.getItem('employee_data'));
    this.state = this.initState();
  }

  initState = () => ({
    open: true,
  });

  componentDidMount = () => {
    M.Collapsible.init(document.querySelectorAll('.collapsible'), {
      accordion: false,
    });
    M.Sidenav.init(document.querySelector('#side-navigation'), {
      draggable: true,
      preventScrolling: false,
      onOpenStart: this.setActiveLink,
    });
  };

  setActiveLink = () => {
    const links = document.querySelectorAll('.sidenav-close');
    links.forEach(el => {
      if (el.getAttribute('href') === window.location.pathname)
        el.classList.add('active');
      else el.classList.remove('active');
    });
  };

  openSideNav = e => {
    e?.preventDefault();
    M.Sidenav.getInstance(document.querySelector('#side-navigation')).open();
  };

  openReminders = e => {
    e?.preventDefault();
    M.Modal.getInstance(
      document.querySelector('#top-level-reminder-modal')
    ).open();
    M.Sidenav.getInstance(document.querySelector('#side-navigation')).close();
  };

  logout = () => {
    localStorage.clear();
    window.location.reload();
  };

  getLinks = () => [
    {
      label: this.employeeData?.id
        ? `${this.employeeData.firstName} ${this.employeeData.lastName}`
        : 'User Menu',
      links: [
        { to: '/user/timeclock', label: 'Time Card' },
        { to: '/user/corrections', label: 'Correction List' },
        { to: '/user/errortracking', label: 'Report An Issue' },
        { to: '/user/featurerequest', label: 'Request A Feature' },
        { to: '/', label: 'Reminders', onClick: this.openReminders },
      ],
    },
    {
      label: 'Warehouse',
      links: [
        { to: '/regular', label: 'Order List' },
        { to: '/redbook', label: 'Redbook' },
        { to: '/indate/sort', label: 'Indate Sort' },
        {
          label: 'Processing',
          links: [
            { to: '/debitmemo', label: 'Debit Memos' },
            { to: '/indate', label: 'Indate Processing' },
            { to: '/utility/bottlelookup', label: 'Bottle Lookup' },
            { to: '/shipping', label: 'Outbound Shipping' },
          ],
        },
        {
          label: 'Controls',
          links: [{ to: '/controls', label: '222 Form' }],
        },
        {
          label: 'Management',
          links: [
            { to: '/warehouse/manager/order/search', label: 'Order Search' },
            { to: '/pharmacy', label: 'Pharmacies' },
            { to: '/manufacturer', label: 'Manufacturers' },
            { to: '/wholesaler', label: 'Wholesalers' },
            { to: '/returnHandler', label: 'Return Handlers' },
            { to: '/buyinggroup', label: 'Buying Groups' },
            { to: '/outbox', label: 'Email Outbox' },
            { to: '/recall', label: 'Recalls' },
            { to: '/warehouse/manager/timeclock', label: 'Timesheet' },
          ],
        },
      ],
    },
    {
      label: 'Accounting',
      links: [
        { to: '/accounting', label: 'Customer List' },
        {
          label: 'Invoicing',
          links: [
            { to: '/invoice', label: 'Awaiting Invoice' },
            { to: '/invoice/search', label: 'Invoice Search' },
          ],
        },
        {
          label: 'Wholesaler Credits',
          links: [
            {
              to: '/accounting/wholesaler/credit/report',
              label: 'Wholesaler Credit Report',
            },
            { to: '/accounting/unmatched/credits', label: 'Unmatched Credits' },
            { to: '/accounting/mckesson', label: 'Mckesson' },
          ],
        },
        {
          label: 'Checks',
          links: [
            {
              to: '/accounting/outbound/checks/overview',
              label: 'Search Checks',
            },
            { to: '/accounting/outbound/checks', label: 'Write Checks' },
          ],
        },
        {
          label: 'Credit Recovery',
          links: [
            { to: '/accounting/report/cardinal', label: 'Cardinal DM Report' },
          ],
        },
        {
          label: 'Reports',
          links: [
            {
              to: '/accounting/report/newcustomer',
              label: 'New Customer Report',
            },
            { to: '/accounting/creditdetail', label: 'Credit Detail' },
            {
              to: '/accounting/report/new_commission',
              label: 'Sales Commission',
            },
            { to: '/accounting/qbexport', label: 'QB Export' },
            {to: '/accounting/report/uninvoiced_orders', label: 'Uninvoiced Orders'}
          ],
        },
      ],
    },
    {
      label: 'Sales',
      links: [
        { to: '/sales', label: 'Contact Log' },
        { to: '/sales/search', label: 'Pharmacy Import' },
        {
          label: 'Reports',
          links: [
            {
              to: '/sales/report/shipmentbybuyinggroup',
              label: 'Shipment By GPO',
            },
          ],
        },
      ],
    },
    {
      label: 'Website Administration',
      links: [
        { to: '/website/administration/permission', label: 'Permissions' },
        {
          to: '/website/administration/customer/portal',
          label: 'Customer Portal',
        },
        {
          label: 'Experimental',
          links: [
            {
              to: '/website/administration/customquery',
              label: 'Custom Query',
            },
          ],
        },
      ],
    },
  ];

  render = () => (
    <div>
      <div>
        <ul id="side-navigation" className="sidenav">
          <li>
            <div
              className="user-view"
              style={{
                display: 'flex',
                flexDirection: 'column',
                padding: '4px 18px',
              }}
            >
              <Link to="/changelog" className="sidenav-close">
                <img
                  src="/img/orx_logo_flat_no_background.png"
                  style={{
                    height: '68px',
                    width: '200px',
                    paddingLeft: '32px',
                  }}
                  alt="Orx Logo"
                />
              </Link>
            </div>
            <div className="divider" />
          </li>
          <li>
            {this.getLinks().map(({ label, links }, index) => (
              <ul key={index} className="collapsible collapsible-accordion">
                <li>
                  <span className="collapsible-header">{label}</span>
                  {links ? (
                    <div className="collapsible-body">
                      <ul className="collapsible collapsible-accordion">
                        {links.map(({ to, label, onClick, links }, index) =>
                          links ? (
                            <li key={index}>
                              <span className="collapsible-header teir-one">
                                {label}
                              </span>
                              <div className="collapsible-body">
                                <ul>
                                  {links.map((l, index) => (
                                    <li key={index}>
                                      <Link
                                        to={l.to}
                                        className="sidenav-close teir-two"
                                      >
                                        {l.label}
                                      </Link>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </li>
                          ) : (
                            <li key={index}>
                              <Link
                                to={to}
                                className="sidenav-close teir one"
                                onClick={onClick}
                              >
                                {label}
                              </Link>
                            </li>
                          )
                        )}
                      </ul>
                    </div>
                  ) : null}
                </li>
              </ul>
            ))}
          </li>
          <li id="logout" className="right">
            <a href="/" onClick={this.logout}>
              {' '}
              Sign Out
              <i className="material-icons right">logout</i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}

const mapStateToProps = state => {
  const { sideNavIsOpen } = state;
  return { sideNavIsOpen };
};

export default connect(mapStateToProps)(SideNav);
